// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FAQ_wrapper__uvQ1y","item":"FAQ_item__NcwZG"};